var styles = {"giphy_player":"aERFs"};

export { styles as s };

import 'wix-rich-content-plugin-giphy/dist/loadable/viewer/es/styles.viewer.min.global.css'